
import { Link } from 'react-router-dom';

const ProgressDashboard = () => {
  const overallProgress = 68; // percentage
  const currentLevel = "Intermediate";
  const nextLevel = "Upper Intermediate";
  const pointsToNextLevel = 750;
  const currentPoints = 1250;

  return (
    <section className="bg-gradient-to-br from-green-600 to-blue-700 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              Your Learning Progress
            </h1>
            <p className="text-xl text-green-100">
              Track your English learning journey and celebrate your achievements!
            </p>
          </div>

          {/* Main Progress Card */}
          <div className="bg-white/10 backdrop-blur-sm rounded-2xl p-8 mb-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
              <div>
                <h2 className="text-3xl font-bold mb-4">Current Level: {currentLevel}</h2>
                <p className="text-green-100 mb-6">
                  You're doing great! Keep practicing to reach {nextLevel} level.
                </p>
                
                <div className="mb-6">
                  <div className="flex justify-between items-center mb-2">
                    <span className="text-sm font-medium">Progress to {nextLevel}</span>
                    <span className="text-sm font-medium">{overallProgress}%</span>
                  </div>
                  <div className="w-full bg-white/20 rounded-full h-3">
                    <div 
                      className="bg-yellow-400 h-3 rounded-full transition-all duration-500"
                      style={{ width: `${overallProgress}%` }}
                    ></div>
                  </div>
                </div>

                <div className="flex items-center space-x-6">
                  <div>
                    <div className="text-2xl font-bold">{currentPoints.toLocaleString()}</div>
                    <div className="text-green-100 text-sm">Total Points</div>
                  </div>
                  <div>
                    <div className="text-2xl font-bold">{pointsToNextLevel}</div>
                    <div className="text-green-100 text-sm">Points to Next Level</div>
                  </div>
                </div>
              </div>

              <div className="text-center">
                <div className="relative inline-block">
                  <svg className="w-48 h-48 transform -rotate-90" viewBox="0 0 100 100">
                    <circle
                      cx="50"
                      cy="50"
                      r="40"
                      stroke="rgba(255,255,255,0.2)"
                      strokeWidth="8"
                      fill="none"
                    />
                    <circle
                      cx="50"
                      cy="50"
                      r="40"
                      stroke="#FCD34D"
                      strokeWidth="8"
                      fill="none"
                      strokeDasharray={`${overallProgress * 2.51} 251`}
                      strokeLinecap="round"
                      className="transition-all duration-500"
                    />
                  </svg>
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="text-center">
                      <div className="text-3xl font-bold">{overallProgress}%</div>
                      <div className="text-sm text-green-100">Complete</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Quick Actions */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Link
              to="/learn"
              className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-colors cursor-pointer"
            >
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-blue-500 rounded-lg flex items-center justify-center">
                  <i className="ri-book-open-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold">Continue Learning</h3>
                  <p className="text-green-100 text-sm">Resume your current lesson</p>
                </div>
              </div>
            </Link>

            <Link
              to="/lessons"
              className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-colors cursor-pointer"
            >
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-purple-500 rounded-lg flex items-center justify-center">
                  <i className="ri-video-chat-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold">Book Lesson</h3>
                  <p className="text-green-100 text-sm">Get personal guidance</p>
                </div>
              </div>
            </Link>

            <button 
              onClick={() => document.getElementById('weekly-goals')?.scrollIntoView({ behavior: 'smooth' })}
              className="bg-white/10 backdrop-blur-sm rounded-xl p-6 hover:bg-white/20 transition-colors cursor-pointer"
            >
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-orange-500 rounded-lg flex items-center justify-center">
                  <i className="ri-target-line text-white text-xl"></i>
                </div>
                <div>
                  <h3 className="font-semibold">Set Goals</h3>
                  <p className="text-green-100 text-sm">Plan your week</p>
                </div>
              </div>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProgressDashboard;
